import { Validator } from '@vista-digital/validator';
import { headingLevelValidator } from '../../../subcomponents/heading/heading';
import { FilmThumbnailMediaType } from '../../film/thumbnail/types/media-type';
export const defaultQuickNavigatorConfig = {
    dropdownLabel: {
        show: true
    },
    sites: {
        enableSearch: true,
        displayAsModalOnMobile: true
    },
    films: {
        mediaType: FilmThumbnailMediaType.Poster,
        enableSearch: true,
        displayAsModalOnMobile: true
    },
    screeningDates: {
        enableSearch: true,
        displayAsModalOnMobile: true
    },
    showtimes: {
        enableSearch: true,
        showScreenName: true,
        displayAsModalOnMobile: true
    },
    headingLabel: {
        show: true,
        headingLevel: 'h3'
    }
};
const quickNavigatorDropdownConfigBaseValidatorSchema = {
    enableSearch: Validator.boolean(),
    displayAsModalOnMobile: Validator.boolean()
};
export const quickNavigatorConfigValidator = Validator.object({
    dropdownLabel: Validator.object({ show: Validator.boolean() }),
    sites: Validator.object(quickNavigatorDropdownConfigBaseValidatorSchema),
    films: Validator.object(Object.assign(Object.assign({}, quickNavigatorDropdownConfigBaseValidatorSchema), { mediaType: Validator.oneOf(Object.values(FilmThumbnailMediaType)) })),
    screeningDates: Validator.object(quickNavigatorDropdownConfigBaseValidatorSchema),
    showtimes: Validator.object(Object.assign(Object.assign({}, quickNavigatorDropdownConfigBaseValidatorSchema), { showScreenName: Validator.boolean() })),
    headingLabel: Validator.object({ show: Validator.boolean(), headingLevel: headingLevelValidator })
});
//# sourceMappingURL=config.js.map